import { render, staticRenderFns } from "./resource-actions.vue?vue&type=template&id=63a39c3c&"
import script from "./resource-actions.vue?vue&type=script&lang=js&"
export * from "./resource-actions.vue?vue&type=script&lang=js&"
import style0 from "./resource-actions.vue?vue&type=style&index=0&id=63a39c3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports